import React from 'react'

import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { useI18n } from '@elo-kit/components/i18n/i18n'

import { linkToImage } from 'utils/ssr.utils'

import Image404 from '../../../../public/images/404.svg'

import './page-not-found.scss'

interface Props {
  hideGoBack?: boolean
  historyGoBack?: () => void
}

const PageNotFound: React.FC<Props> = ({ hideGoBack, historyGoBack }) => {
  const I18n = useI18n()

  return (
    <div className='page-not-found'>
      <img src={linkToImage(Image404)} alt='404' />
      <div className='page-not-found__error-text'>{I18n.t('react.shared.error.page_not_found')}</div>

      <div className='elo-btn-container elo-btn-container--right elo-btn-container--no-margin'>
        {!hideGoBack && (
          <EloButton orange onClick={historyGoBack}>
            {/*it's actual get BACK translation */}
            {I18n.t('react.shared.elopage_home')}
          </EloButton>
        )}
        <EloButton orange onClick={() => window.location.assign('/')}>
          {/*it's actual get HOME translation */}
          {I18n.t('react.shared.error.get_back')}
        </EloButton>
      </div>
    </div>
  )
}

export default PageNotFound
